import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  inject,
} from '@angular/core';

import { Button } from 'primeng/button';
import { FormControlComponent, PrimengButtonDirective } from '@web/shared/ui';
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Nillable } from '@web/utils';
import {
  AdminSubscriptionBulkPriceChangeForm,
  AdminSubscriptionBulkPriceChangeFormGroup,
} from '../../models/admin-subscription-bulk-price-change-form';
import { InputNumber } from 'primeng/inputnumber';

@Component({
  selector: 'app-admin-subscription-bulk-price-change-form',
  imports: [
    Button,
    FormControlComponent,
    FormsModule,
    PrimengButtonDirective,
    ReactiveFormsModule,
    InputNumber,
  ],
  templateUrl: './admin-subscription-bulk-price-change-form.component.html',
  styleUrl: './admin-subscription-bulk-price-change-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminSubscriptionBulkPriceChangeFormComponent implements OnInit {
  private readonly builder = inject(FormBuilder);

  /* prettier-ignore */
  public readonly data = input<Nillable<AdminSubscriptionBulkPriceChangeForm>>();
  /* prettier-ignore */
  public readonly submitClickEvent = output<AdminSubscriptionBulkPriceChangeForm>();

  protected readonly form = this.buildForm();

  public ngOnInit(): void {
    this.fillByData();
  }

  public handleSubmitClick(): void {
    this.submitClickEvent.emit(this.toData());
  }

  private toData(): AdminSubscriptionBulkPriceChangeForm {
    const data = this.form.getRawValue();

    return new AdminSubscriptionBulkPriceChangeForm({
      price: data.price!,
    });
  }

  private buildForm(): AdminSubscriptionBulkPriceChangeFormGroup {
    /* prettier-ignore */
    return this.builder.group({
      price: this.builder.control<Nillable<number>>(null, [Validators.required, Validators.min(AdminSubscriptionBulkPriceChangeForm.PriceMin)]),
    });
  }

  private fillByData(): void {
    const data = this.data();

    this.form.patchValue({
      price: data?.price,
    });
  }
}
